import React, { useEffect, useState } from 'react';
import '../style/global.css';

const SidebarLeft = () => {
    return(
            <div className="sidebarleft">
                <div className='logo'>
                    <a href="/">
                      GroundZero.ma  
                    </a>
                    
                </div>
            </div>
    )
}

export default SidebarLeft;